import { Descriptions, Divider } from "antd";
 import { Typography } from "antd";
 import { labelStyle } from "../RequestUtil";

 const { Title } = Typography;

 const CommonCriminalSexualRequest = ({ serviceData, requestData }) => {
   const reactiveColumn = {
     xxl: 1,
     xl: 1,
     lg: 1,
     md: 1,
     sm: 1,
     xs: 1,
   };

   const clientTypeUI = () => {
    if (serviceData.clientType === "가해자") {
        return serviceData.expectResult;
    } else if (serviceData.clientType === "피해자") {
        return serviceData.expectResult.join(", ");
    } else {
        return "";
    }
   }

   const clientTypeEtcUI = () => {
    if (serviceData.clientType === "가해자") {        
        return serviceData.expectOffenderEtcResult;
    } else if (serviceData.clientType === "피해자") {
        return serviceData.expectDefenderEtcResult;
    } else {
        return "";
    }
   }
   
   return (
     <>
       <Title level={4} style={{ color: "#001529", marginBottom: 0 }}>
       형사 사건 성범죄
       </Title>
       <Divider style={{ marginTop: 10 }} />
       <div
         style={{
           backgroundColor: "white",
           padding: 15,
           paddingTop: 5,
           marginBottom: 20,
           borderRadius: 5,
         }}
       >
         <Descriptions
           title="형사 사건 성범죄 관련 정보"
           bordered
           column={reactiveColumn}
           size={"small"}
           style={{ marginTop: 20, marginBottom: 15 }}
         >

           <Descriptions.Item
             label="사건의 종류"
             labelStyle={labelStyle}
           >
             {serviceData.criminalCaseType.join(", ")}
           </Descriptions.Item>

           {serviceData.criminalCaseType.includes("기타") ? (
             <Descriptions.Item label="기타 이유" labelStyle={labelStyle}>
               {serviceData.criminalEtcCaseType}
             </Descriptions.Item>
           ) : null}

           <Descriptions.Item label="의뢰인 입장" labelStyle={labelStyle}>
             {serviceData.clientType}
           </Descriptions.Item>

           <Descriptions.Item
             label="의뢰인이 원하는 결과"
             labelStyle={labelStyle}
           >
             {clientTypeUI()}
           </Descriptions.Item>

           {serviceData.expectResult.includes("기타") ? (
             <Descriptions.Item label="의뢰인이 원하는 기타 이유" labelStyle={labelStyle}>
               {clientTypeEtcUI()}
             </Descriptions.Item>
           ) : null}

           <Descriptions.Item
             label="상세 주소"
             labelStyle={labelStyle}
           >
             {serviceData.address}
           </Descriptions.Item>
         </Descriptions>

         <Descriptions
           title="상세 내용 및 연락처"
           bordered
           column={reactiveColumn}
           size={"small"}
           style={{ marginTop: 20, marginBottom: 15 }}
         >           
           <Descriptions.Item label="상세 내용" labelStyle={labelStyle}>
             {serviceData.desc
               ? serviceData.desc.split("\n").map((line, idx) => {
                   return (
                     <span key={idx}>
                       {line}
                       <br />
                     </span>
                   );
                 })
               : ""}
           </Descriptions.Item>
           <Descriptions.Item label="연락처" labelStyle={labelStyle}>
             {serviceData.contact}
           </Descriptions.Item>
           <Descriptions.Item label="프로모션" labelStyle={labelStyle}>
             {serviceData.promotionCode}
           </Descriptions.Item>
         </Descriptions>
       </div>
     </>
   );
 };

 export default CommonCriminalSexualRequest;